import { createAction } from '@ngrx/store';

// If dispatched will clear the text on the search input
export const FIELD_RESPONSE_QUICK_SEARCH_CLEAR_SEARCH_TEXT = createAction(
  '[FieldResponseQuickSearchComponent] CLEAR_SEARCH_TEXT'
);
